import React from 'react';
import styled from 'styled-components';
import { Container } from 'components/basics';
import PostBlock from 'components/pages/Blog/Post/PostBlock';

const ContainerBlock = styled(Container)`
  margin-bottom: 1.5em;
`;

const PostsListBlock = ({ data, lang }) => {
  const dataToIterate = data && (data.articlesList || data);
  return (
    <ContainerBlock>
      {dataToIterate.map(article => {
        const articleData = {
          ...article,

          thumbnail: article?.thumbnail?.url,
        };
        return (
          <PostBlock
            key={`post-${article.id}`}
            data={articleData}
            lang={lang}
          />
        );
      })}
    </ContainerBlock>
  );
};

export default PostsListBlock;
